import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input } from '@angular/core';
import { StripSpecialCharsPipe } from '../strip-special-chars/strip-special-chars.pipe';
import { KlaDataService } from '../services/kla.data.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-social-media-buttons',
  templateUrl: './social-media-buttons.component.html',
  styleUrls: ['./social-media-buttons.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class SocialMediaButtonsComponent {
  isShown: boolean = false;

  @Input() set linkFragment(value) {
    this._linkFragment = value;
  }

  @Input() image;

  shortUrl: any;

  private _linkFragment;

  constructor(
    private route: Router,
    private dataService: KlaDataService,
    private router: ActivatedRoute
  ) {

    this.router.queryParams.subscribe((param) => {
      let fragment = param?.component;
      if(fragment && fragment != null && fragment != undefined) {
        document.getElementById(fragment).scrollIntoView({
          block: 'center'
        });
      }
    })

   }

   get currentUrl() {
    return window.location.href.split('#')[0];
  }

   toggleDropdown() {
    this.isShown = true;
   }

  getFragmentLink() {
    return this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);;
  }


  private addUtmParams(url: string): string {
    // First remove any existing UTM params
    const cleanUrl = this.removeUtmParams(url);
    const separator = cleanUrl.includes('?') ? '&' : '?';

    const utmParams = `utm_campaign=kla_share_button`;

    // If URL has a hash fragment, insert UTM params before the hash
    if (cleanUrl.includes('#')) {
      const [shareUrl, hash] = cleanUrl.split('#');
      return `${shareUrl}${separator}${utmParams}#${hash}`;
    }

    return `${cleanUrl}${separator}${utmParams}`;
  }

  private removeUtmParams(url: string): string {
    const [urlWithoutHash, hash] = url.split('#');
    if (!urlWithoutHash.includes('?')) {
      return url;
    }

    const [path, queryString] = urlWithoutHash.split('?');
    const cleanParams = queryString
      .split('&')
      .filter(param => !param.startsWith('utm_'))
      .join('&');

    let result = cleanParams ? `${path}?${cleanParams}` : path;
    return hash ? `${result}#${hash}` : result;
  }

  copyToClipboard() {
    const fragmentLink = this.getFragmentLink();
    const urlWithUtm = this.addUtmParams(fragmentLink);

    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = urlWithUtm;
    document.body.appendChild(tempInput);

    // Copy the text from the input field
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy link:', err);
    }

    // Remove the temporary input element
    document.body.removeChild(tempInput);
  }

  getFaceBookURL() {
    const shareUrl = this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);
    const urlWithUtm = this.addUtmParams(shareUrl);

    window.open('http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(urlWithUtm), 'sharer', 'top=' + '200' + ',left=' + '200' + ',toolbar=0,status=0,width='+'500'+',height='+'500');
  }

  getTwitterURL(){
    const shareUrl = this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);
    const urlWithUtm = this.addUtmParams(shareUrl);

    return `https://x.com/intent/post?text=${this._linkFragment}&url=${encodeURIComponent(urlWithUtm)}`;
  }

 getLinkedInURL() {
    const shareUrl = this.currentUrl + '?component=' + StripSpecialCharsPipe.strip(this._linkFragment);
    const urlWithUtm = this.addUtmParams(shareUrl);

    window.open('http://www.linkedin.com/shareArticle?url=' + encodeURIComponent(urlWithUtm), 'sharer', 'top=' + '200' + ',left=' + '200' + ',toolbar=0,status=0,width='+'500'+',height='+'500');
 }

 getBlueskyURL() {
  const shareUrl = this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);
  const urlWithUtm = this.addUtmParams(shareUrl);
  return `https://bsky.app/intent/compose?text=${encodeURIComponent(this._linkFragment + ' ' + urlWithUtm)}`
 }

 getThreadsURL() {
  const shareUrl = this.currentUrl + '#' + StripSpecialCharsPipe.strip(this._linkFragment);
  const urlWithUtm = this.addUtmParams(shareUrl);
  return `https://www.threads.net/intent/post?text=${encodeURIComponent(this._linkFragment + ' ' + urlWithUtm)}`
 }

 setIconColor() {
  let color = {
    'fill': `${'#fff'}`
  }
  return color;
 }

}
